// caiet UC91-14 / ACCS-09 — the lot selector's options: the lots of the stock the
// role reaches ("conform rapoartelor la care aceștia au acces"), searched and paged
// on the server, never loaded whole. Narrowed by the Registrars and sites already
// chosen, the filters upstream of it (UC91-15).
import {
  useInfiniteQuery,
  type UseInfiniteQueryResult,
  type InfiniteData,
} from '@tanstack/react-query';
import { apiClient } from '../../app/api-client';

export const LOTS_PAGE_SIZE = 20;

export interface StockLotsPage {
  lots: string[];
  hasMore: boolean;
}

export interface StockLotsQuery {
  query: string;
  registrarIds: string[];
  siteIds: string[];
  enabled: boolean;
}

async function listStockLots(
  query: Omit<StockLotsQuery, 'enabled'>,
  offset: number,
): Promise<StockLotsPage> {
  const params: Record<string, string> = {
    offset: String(offset),
    limit: String(LOTS_PAGE_SIZE),
  };
  if (query.query.length > 0) params['q'] = query.query;
  if (query.registrarIds.length > 0) params['registrarIds'] = query.registrarIds.join(',');
  if (query.siteIds.length > 0) params['siteIds'] = query.siteIds.join(',');
  const { data } = await apiClient.get<StockLotsPage>('/stock/timeseries/lots', { params });
  return { lots: data.lots ?? [], hasMore: data.hasMore ?? false };
}

export function useStockLots(
  query: StockLotsQuery,
): UseInfiniteQueryResult<InfiniteData<StockLotsPage>> {
  const { enabled, ...criteria } = query;
  return useInfiniteQuery({
    queryKey: ['uc91-stock-lots', criteria.query, criteria.registrarIds, criteria.siteIds],
    queryFn: ({ pageParam }) => listStockLots(criteria, pageParam),
    initialPageParam: 0,
    getNextPageParam: (last, pages) => (last.hasMore ? pages.length * LOTS_PAGE_SIZE : undefined),
    enabled,
    staleTime: 30_000,
    retry: false,
  });
}
